<template>

  <div style="width: 75rem;" class="text-center">
    <div v-if="showBadge()">

      <h3 class="mb-5">Congratulations! The following badge has been awarded</h3>

      <div class="row">
        <div class="col">

          <!-- <img :src="badge.data.image" class="mb-1"/> -->
          <img :src="getImageBadge()" width="400px" class="mb-5"/>

          <div class="row" style="justify-content: center;">
            <a :href="getVerificationURL()" target="_blank" class="badge_button linkInPDF">Verify</a>
            <a :href="getOpenBadgeID()" target="_blank" class="badge_button linkInPDF">Go to Badgr's award page</a>
          </div>
          <div class="row hideInPDF" style="justify-content: center; margin-top: 20px;">
            <div>Share your badge in popular code and data repository platforms using Markdown</div>
          </div>
          <div class="row hideInPDF" style="justify-content: center; margin-top: 8px;">
            <button class="btn btn-primary btn-fill" id="badge_image_clipboard_button" @click="badge_image_to_clipboard()" style="margin-right: 5px;" data-toggle="tooltip" data-placement="left" title="Code to use a 150x116 pixel sized image in your README"><i class="fa fa-clone"></i> Get Badge Image</button>
            <button class="btn btn-primary btn-fill" id="badge_shield_clipboard_button" @click="badge_shield_to_clipboard()" data-toggle="tooltip" data-placement="right" title="Code to use the popular shields.io"><i class="fa fa-clone"></i> Get Badge Shield</button>
          </div>

          <div v-if="permalink">
            <div class="row hideInPDF" style="justify-content: center; margin-top: 20px;">
              <div>Get a permalink of this badge assessment report</div>
            </div>
            <div class="row hideInPDF" style="justify-content: center; margin-top: 8px;">
              <button class="btn btn-primary btn-fill" id="permalink_clipboard_button" @click="permalink_to_clipboard()" style="margin-right: 5px;"><i class="fa fa-link"></i> Get Permalink</button>
            </div>
          </div>

          <div class="row" id="badge_clipboard_alert" style="justify-content: center; margin-top: 20px;">
            <div class="alert alert-success" role="alert" style="margin: 0 30%; background-color: #d4edda; border-color: #c3e6cb; color: #155724;">
              <i class="fa fa-check-circle" aria-hidden="true" style="margin-right: 5px"></i> <span id="badge_clipboard_alert_text">Your badge has been copied to the clipboard</span>
            </div>
          </div>

        </div>

      </div>

    </div>

    <div v-else>

      <h3 class="mb-4"> Sorry, you have not earned any badge</h3>
      <img src="../../../static/badges/no_badge_blur.png" width="300px"/>

    </div>

    <h4><a href="https://docs.sqaaas.eosc-synergy.eu/quality_assessment_and_awarding/synergy_badging_approach" target="_blank" class="linkInPDF">Learn more about the EOSC-Synergy badging approach</a></h4>

  </div>

</template>

<script>
export default {
  name: "BadgeAchieved",
  props: ['badge','permalink'],
  methods:{
    showBadge(){
      return this.badge.software && this.badge.software.verification_url || this.badge.services && this.badge.services.verification_url || this.badge.fair && this.badge.fair.verification_url
    },
    getAssessmentType(){
      if (this.badge.software) return "software"
      if (this.badge.services) return "services"
      if (this.badge.fair)     return "fair"
    },
    getBadgeLevel(){
      let assessmentType = this.getAssessmentType()

      if (this.badge[assessmentType].criteria.bronze.missing.length > 0) return "no_badge"
      if (this.badge[assessmentType].criteria.silver.missing.length > 0) return "bronze"
      if (this.badge[assessmentType].criteria.gold.missing.length > 0)   return "silver"
      return "gold"
    },
    getShieldColor(){
      let badgeLevel = this.getBadgeLevel()

      if (badgeLevel === "bronze") return "e6ae77"
      if (badgeLevel === "silver") return "lightgrey"
      else return "yellow" // Gold
    },
    getImageBadge(){
      return require('../../../static/badges/badge_'+this.getAssessmentType()+'_'+this.getBadgeLevel()+'.png')
    },
    getVerificationURL(){
      return this.badge[this.getAssessmentType()].verification_url
    },
    getOpenBadgeID(){
      return this.badge[this.getAssessmentType()].data.openBadgeId
    },
    badge_image_to_clipboard(){
      $('#badge_image_clipboard_button').tooltip('hide')
      let badgeImage = '[![SQAaaS badge](https://github.com/EOSC-synergy/SQAaaS/raw/master/badges/badges_150x116/badge_' + this.getAssessmentType() + '_' + this.getBadgeLevel() + '.png)](' + this.getOpenBadgeID() + ' "SQAaaS ' + this.getBadgeLevel() + ' badge achieved")'
      navigator.clipboard.writeText(badgeImage);
      $('#badge_clipboard_alert_text').text('Your badge image has been copied to the clipboard')
      $('#badge_clipboard_alert').fadeIn(300).delay(3000).fadeOut(300);

    },
    badge_shield_to_clipboard(){
      $('#badge_shield_clipboard_button').tooltip('hide')
      let badgeShield = '[![SQAaaS badge shields.io](https://img.shields.io/badge/sqaaas%20' + this.getAssessmentType() + '-' + this.getBadgeLevel() + '-' + this.getShieldColor() + ')](' + this.getOpenBadgeID() + ' "SQAaaS ' + this.getBadgeLevel() + ' badge achieved")'
      navigator.clipboard.writeText(badgeShield);
      $('#badge_clipboard_alert_text').text('Your badge shield has been copied to the clipboard')
      $('#badge_clipboard_alert').fadeIn(300).delay(3000).fadeOut(300);
    },
    permalink_to_clipboard(){
      navigator.clipboard.writeText(this.permalink);
      $('#badge_clipboard_alert_text').text('Your assessment report permalink has been copied to the clipboard')
      $('#badge_clipboard_alert').fadeIn(300).delay(3000).fadeOut(300);
    },

    mounted(){
      $('[data-toggle="tooltip"]').tooltip()
    }
  }
}
</script>

<style scoped>

h3{
  color: #6c757d;
  font-weight: bold;
}

.badge_button{
  font-size:18px;
  border:1px solid;
  margin-right: 0.25rem;
  padding: 0 20px;
}

#badge_clipboard_alert{
  display: none;
}

</style>
